import React from "react";
import { useTranslation } from "react-i18next";
import { TypeSpecificFieldsProps } from "./types";
import { useFieldChoices } from "./useFieldChoices";

const TravelFields: React.FC<TypeSpecificFieldsProps> = ({ data, onChange }) => {
  const { t } = useTranslation(['insurance', 'common']);
  const set = (key: string, value: any) => onChange({ ...data, [key]: value });

  const tripTypes = useFieldChoices("travel", "trip_type");

  return (
    <div className="irf-grid">
      <div className="irf-field">
        <label>{t('insurance:travel.destination')}</label>
        <input
          value={data.destination || ""}
          onChange={(e) => set("destination", e.target.value)}
          placeholder={t('insurance:travel.destinationPlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:travel.tripType')}</label>
        <select
          value={data.trip_type || ""}
          onChange={(e) => set("trip_type", e.target.value)}
        >
          <option value="">{t('insurance:travel.selectTripType')}</option>
          {tripTypes.map((tp) => (
            <option key={tp.value} value={tp.value}>{tp.label}</option>
          ))}
        </select>
      </div>
      <div className="irf-field">
        <label>{t('insurance:travel.medicalCoverage')}</label>
        <input
          type="number"
          value={data.medical_coverage ?? ""}
          onChange={(e) => set("medical_coverage", e.target.value ? Number(e.target.value) : "")}
          placeholder={t('insurance:travel.medicalCoveragePlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:travel.coverageAmount')}</label>
        <input
          type="number"
          value={data.coverage_amount ?? ""}
          onChange={(e) => set("coverage_amount", e.target.value ? Number(e.target.value) : "")}
          placeholder={t('insurance:travel.totalCoveragePlaceholder')}
        />
      </div>
      <div className="irf-field irf-checkbox-field">
        <label>
          <input
            type="checkbox"
            checked={!!data.baggage_loss_cover}
            onChange={(e) => set("baggage_loss_cover", e.target.checked)}
          />
          {t('insurance:travel.baggageLossCover')}
        </label>
      </div>
      <div className="irf-field irf-checkbox-field">
        <label>
          <input
            type="checkbox"
            checked={!!data.trip_cancellation_cover}
            onChange={(e) => set("trip_cancellation_cover", e.target.checked)}
          />
          {t('insurance:travel.tripCancellationCover')}
        </label>
      </div>
    </div>
  );
};

export default TravelFields;
